var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"appup-button",attrs:{"id":_vm.id,"size":_vm.buttonSize,"variant":_vm.buttonVarient,"title":_vm.tooltip,"type":_vm.type,"disabled":_vm.disabled},on:{"click":_vm.onButtonClick}},[(_vm.icon)?[_c('icon',{attrs:{"name":_vm.icon}})]:_vm._e(),_vm._v("\n    "+_vm._s(_vm.label)+"\n")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/button/button.vue